// enum с перечислениями длительности ставки в миутах. Т.е. после указанной длительности если нет новой ставки то торги заврешаются по лоту.
export enum StepBetType {
    IsValue = 1,
    IsPercent = 2,
    Noset = 3
}
